import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-contracts-type',
  templateUrl: './add-contracts-type.component.html',
  styleUrls: ['./add-contracts-type.component.scss']
})
export class AddContractsTypeComponent implements OnInit {

formData: any = {

  name_ar: '',
  name_en: '',
};
 
 
  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,
        private translate: TranslateService
  ) {}

    ngOnInit(): void {
  
    }
 
  onFileSelected(event: any): void {
  if (event.target.files.length > 0) {
    this.formData.image = event.target.files[0];
  }
}
    cancel(): void {
      this.router.navigate(['/contracts-type']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit(): void {
  const form = new FormData();

  form.append('name_ar', this.formData.name_ar);
  form.append('name_en', this.formData.name_en);

  this.apisService.addContracts_type(form).subscribe({
    next: (response: any) => {
      console.log('Contract type added successfully:', response);
      this.toastr.success(this.translate.instant('MENU.DASHBOARD.contract_type_added_successfully'));
      this.router.navigate(['/contracts-type']);
    },
    error: (error: any) => {
      console.error('Error adding contract type:', error);
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.something_went_wrong'));
    }
  });
}


}